module.exports = __webpack_public_path__ + "img/kolekcja.5e79ee2c.jpg";